import { render, staticRenderFns } from "./trainAdminCreationCompetitionSucceed.vue?vue&type=template&id=4962f984&scoped=true"
import script from "./trainAdminCreationCompetitionSucceed.vue?vue&type=script&lang=js"
export * from "./trainAdminCreationCompetitionSucceed.vue?vue&type=script&lang=js"
import style0 from "./trainAdminCreationCompetitionSucceed.vue?vue&type=style&index=0&id=4962f984&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962f984",
  null
  
)

export default component.exports